const EnvironmentalAuditAttachments = [

  // {
  //   name: "Company Registration Certificate",
  //   description: "Company Registration Certificate",
  //   is_mandatory: true,
  //   info: "",
  // },
  {
    name: "photos_maps_reports",
    description:
      "Photos, maps, reports, or any documents about the project and its zone",
    is_mandatory: true,
    info: "",
  },
  {
    name: "Land Documents",
    description: "Land Documents",
    is_mandatory: true,
    info: "",
  },
  // {
  //   name: "Environmental Audit Report",
  //   description: "Environmental Audit Report",
  //   is_mandatory: false,
  //   info: "",
  // },
]

export const EIA_Attachments = [
  // {
  //   name: "EIA Certificate",
  //   description: "EIA Certificate",
  //   is_mandatory: true,
  //   info: "",
  // },
  // {
  //   name: "Conditions of Approval",
  //   description: "Conditions of Approval",
  //   is_mandatory: true,
  //   info: "",
  // },
  // {
  //   name: "EIA Report",
  //   description: "EIA Report",
  //   is_mandatory: true,
  //   info: "",
  // },
]

export const Other_Env_Audit_Attachments = [
  // {
  //   name: "Audit Certificate",
  //   description: "Audit Certificate",
  //   is_mandatory: true,
  //   info: "",
  // },
  // {
  //   name: "Conditions of Approval",
  //   description: "Conditions of Approval",
  //   is_mandatory: true,
  //   info: "",
  // },
  // {
  //   name: "EIA Report",
  //   description: "EIA Report",
  //   is_mandatory: true,
  //   info: "",
  // },
]

export default EnvironmentalAuditAttachments
